export default "__VITE_ASSET__BIlrzwNg__"